import React from 'react';
import {
  Flex,
  Heading,
  Img,
  Input,
  InputGroup,
  InputLeftElement,
  Text,
} from '@chakra-ui/react';
import Image from 'next/image';

interface ResoucrcesIProps {
  heading: string;
  desc?: string;
  searchBar?: boolean;
  inputPlaceHolder?: string;
  maxW?: string;
  textWidth?: string;
  companyLogo?: string;
  onInputChange?: React.Dispatch<React.SetStateAction<string>>;
}

const ResourceLayout: React.FC<ResoucrcesIProps> = ({
  heading,
  desc,
  searchBar,
  inputPlaceHolder,
  maxW,
  textWidth,
  companyLogo,
  onInputChange = () => {},
}) => (
  <Flex
    pt={{ xs: '30px', sm: '50px', md: '80px', lg: '108px' }}
    flexDir="column"
    mx="auto"
    alignItems="center"
    px="20px"
  >
    {companyLogo && (
      <Img maxW="20vw" src={companyLogo} alt={heading} pb="20px" />
    )}
    <Heading
      as="h1"
      variant="headingText"
      fontSize={{ xs: '34px', sm: '48px', lg: '54px' }}
      textAlign="center"
      pb={desc ? '16px' : '30px'}
      maxW={maxW}
    >
      {heading}
    </Heading>

    {desc !== '' && (
      <Text
        variant="contentText"
        fontSize="16px"
        color="text.headingBlue"
        textAlign="center"
        pb={desc ? '32px' : '16px'}
        maxW={textWidth || '500px'}
      >
        {desc}
      </Text>
    )}

    {searchBar && (
      <InputGroup width={{ xs: '90%', sm: '371px' }} alignItems="center">
        <InputLeftElement pl={{ xs: '10px', sm: '20px' }} mt="6px">
          <Image
            src="/svg/search.svg"
            alt="search icon"
            width={22}
            height={22}
          />
        </InputLeftElement>
        <Input
          aria-label="Search"
          bg="white"
          placeholder={inputPlaceHolder}
          pl={{ xs: '50px', sm: '64px' }}
          fontSize="14px"
          fontWeight="600"
          border="1px solid #EDEDED"
          boxShadow="0px 4px 84px rgba(100, 100, 140, 0.13)"
          _placeholder={{ color: 'rgba(61, 61, 95, 0.29)', fontWeight: '600' }}
          _focus={{
            border: '1px solid',
            borderColor: 'primary.500',
            boxShadow: 'none',
          }}
          h="52px"
          onChange={(e) => onInputChange(e.target.value)}
        />
      </InputGroup>
    )}
  </Flex>
);

export default ResourceLayout;
